export default __webpack_public_path__ + "static/media/cross.86cdb724.svg";